import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/core/services/lang.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { UnitPreferenceService } from 'src/app/core/services/unit-preference.service';
import { ChangePasswordComponent } from 'src/app/core/helper/components/change-password/change-password.component';
import { UserAgreementComponent } from 'src/app/core/helper/components/user-agreement/user-agreement.component';
import { environment } from 'src/environments/environment';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  appVersion = null;
  constructor(private langService: LanguageService, private unitPrefService: UnitPreferenceService, private modalService: ModalService) { }

  ngOnInit() {
    if (Capacitor.isNativePlatform())
      App.getInfo().then(response => {
        this.appVersion = response.version
      })
  }

  changeUnitPreferances() {
    this.unitPrefService.openPrefModal();
  }

  changeLanguage() {
    this.langService.openOptionsMenu()
  }

  changePassword() {
    this.modalService.presentModal({
      component: ChangePasswordComponent,
      componentProps: {},
      options: ModalService.defaultOptionsTransparent
    }).then(res => {
    }).catch(err => {
    })
  }

  openKvkk() {
    this.modalService.presentModal({
      component: UserAgreementComponent,
      componentProps: {
        document: environment.kvkk,
        title: this.langService.getTranslation("auth.kvkk_header"),
        showConfirmBtn: false
      },
      options: {}
    }).then(modalFP => {
      modalFP.modalObj.onDidDismiss().then(dismiss => {

      });
    });
  }

  openTermsOfUse() {
    this.modalService.presentModal({
      component: UserAgreementComponent,
      componentProps: {
        document: environment.termsOfUse,
        title: this.langService.getTranslation("auth.terms-of-use"),
        showConfirmBtn: false
      },
      options: {}
    }).then(modalFP => {
      modalFP.modalObj.onDidDismiss().then(dismiss => {
      });
    });
  }
  openCommercial() {
    this.modalService.presentModal({
      component: UserAgreementComponent,
      componentProps: {
        document: environment.commercialElectronicMessage,
        title: this.langService.getTranslation("auth.commercial_electronic_message_agreement"),
        showConfirmBtn: false
      },
      options: {}
    }).then(modalFP => {
      modalFP.modalObj.onDidDismiss().then(dismiss => {

      });
    });
  }
  openSms() {
    this.modalService.presentModal({
      component: UserAgreementComponent,
      componentProps: {
        document: this.langService.getTranslation("auth.electronic-message"),
        title: this.langService.getTranslation("profile.electronic-message"),
        showConfirmBtn: false
      },
      options: {}
    }).then(modalFP => {
      modalFP.modalObj.onDidDismiss().then(dismiss => {
      });
    });
  }
}
